import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    typography: {
        fontFamily: 'Roboto Flex, Arial, sans-serif',
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#fff',
                    color: 'black',
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
              root: {
                cursor: "default",
              },
            },
          },
    }
});